import { cn } from "@/utils/theme";
import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import type { NodeData } from "@/workflow_api/types/workflow";
import { VariableKeyBox } from "../key-box";

const Content = ({ node }: { node: NodeData; flowId: string }) => {
  const documentsSigned = node.inputs.find(
    (input) => input.name === "generated_documents",
  )?.documents;

  return (
    <div className="flex">
      <div
        className={cn("w-0.5 relative translate-x-[25px]", "bg-transparent")}
      >
        <span className="absolute left-3 top-[14px] w-2 h-2 bg-neutral-object-accent rounded-full"></span>
        <span className="absolute w-3 h-5 border-l-2 border-t-2 border-neutral-object-accent rotate-x-180 rounded-tl-md"></span>
      </div>

      <div className="relative pl-[50px] mb-4 w-full">
        <div className="py-1">
          <div className="space-y-3">
            {documentsSigned?.map((variable, index) => {
              return variable.inputs.map((doc) => {
                return (
                  <VariableKeyBox
                    key={`variable-${doc}-${index}`}
                    name={doc.name}
                    type="file"
                  />
                );
              });
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export const SingDocumentVariables = ({ id }: { id: string }) => {
  const { getNodeById, flowId } = useWorkflowStore();
  const node = getNodeById(id);

  if (!node) return <></>;

  return <Content node={node.data as unknown as NodeData} flowId={flowId} />;
};
